import * as React from 'react';
import { useEffect, useState } from 'react';
import { IUser } from '../../../model/user/IUser';
import { Button, Col, Dropdown, DropdownButton, Form, Row, Table } from 'react-bootstrap';
import { AgencyService } from '../AgencyService';
import { useNavigate } from 'react-router';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import { ErrorToast } from '../../../utils/toasters';
import Flag from '../../../shared/components/Flag';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ITableColumn } from '../../../shared/components/TableSkeleton';
import SingleSelectDropdown from '../../../shared/components/SingleSelectDropdown';

const AGENCY_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Display name' },
    { label: 'Creator Email' },
    { label: 'Pending emails', className: 'text-center' },
    { label: 'Managers', className: 'text-center' },
    { label: 'Influencers', className: 'text-center' },
    { label: 'Country' },
    { label: 'Action' },
];

export function ListAgency() {
    const navigate = useNavigate();

    const [state, setState] = useState({
        perPage: 15,
        page: 1,
        displayName: '',
        email: '',
    });

    const [agencies, setAgencies] = useState<IUser[]>([]);
    const [change, setChange] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        AgencyService.getAgencies(state)
            .then(data => {
                setAgencies(data.data);
                setTotalPages(Math.ceil(data.count / state.perPage));
            })
            .catch(err => ErrorToast(err))
            .finally(() => setIsLoading(false));
    }, [change]);

    // function disableUsers(id: number) {
    //   AgencyService.disableUser(id)
    //     .then((data) => {
    //       let test = [...user];
    //       const found = test.find((x) => x.id === id);
    //       const index = found ? test.indexOf(found) : 0;
    //       test[index] = data;
    //       setUser(test);
    //     })
    //     .catch((err) => {});
    // }

    function handleClick() {
        setChange(!change);
    }

    const handlePages = (updatePage: number) => {
        setState({ ...state, page: updatePage });
        setChange(!change);
    };

    function handleChange(evt: any) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value?.trim(),
        });
    }

    return (
        <>
            {/*<Button*/}
            {/*    variant="outline-primary"*/}
            {/*    onClick={() => navigate(`/agency/create`)}*/}
            {/*>*/}
            {/*    + Add agency user*/}
            {/*</Button>*/}

            <div
                className="card mb-5 p-4 mt-3"
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        handleClick();
                        setState({ ...state, page: 1 });
                    }
                }}
            >
                <Row>
                    <Form.Group as={Col}>
                        <Form.Control
                            placeholder="Id"
                            className="autocomplete-input"
                            name="id"
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Form.Control
                            placeholder="Display name"
                            className="autocomplete-input"
                            name="displayName"
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Form.Control
                            placeholder="Email"
                            className="autocomplete-input"
                            name="email"
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <SingleSelectDropdown
                            placeholder="Has Existing?"
                            options={[
                                { value: 'true', label: 'Existing' },
                                { value: 'false', label: 'Not Existing' },
                            ]}
                            selected={
                                (state as any).hasExisting && (state as any).hasExisting !== 'undefined'
                                    ? String((state as any).hasExisting)
                                    : ''
                            }
                            onChange={value =>
                                handleChange({ target: { name: 'hasExisting', value: value || 'undefined' } })
                            }
                        />
                    </Form.Group>
                </Row>

                <div className="mt-4">
                    <Button
                        type="submit"
                        onClick={() => {
                            handleClick();
                            setState({ ...state, page: 1 });
                        }}
                    >
                        Search
                    </Button>
                </div>
            </div>

            <TableLayout
                pagination={{ page: state.page, totalPages: totalPages }}
                handlePages={handlePages}
                listLength={agencies.length}
                dataName="agency"
                skeletonColumns={AGENCY_COLUMNS}
                skeletonRows={state.perPage}
                isLoading={isLoading}
            >
                <Table hover responsive>
                    <thead>
                        <tr>
                            {AGENCY_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {agencies?.map(e => (
                            <tr key={e.id}>
                                <td>{e.id}</td>
                                <td>
                                    {e.displayName}
                                    <br />
                                    {e?.createdBy?.firstName} {e?.createdBy?.lastName}
                                </td>
                                <td>
                                    <ImpersonateEye id={e?.createdBy?.id ?? 0} />
                                    {e?.createdBy?.email}
                                </td>
                                <td className="text-center">{e?.invitedInfluencers?.length ?? 0}</td>
                                <td className="text-center">{e?.managersCount ?? 0}</td>
                                <td className="text-center">{e?.influencersCount ?? 0}</td>
                                <td>
                                    <Flag code={e?.contact?.country} />
                                </td>
                                <td>
                                    <DropdownButton title="Actions" id="dropdown-menu-align-right">
                                        <Dropdown.Item eventKey="1" onClick={() => navigate('/agency/edit/' + e.id)}>
                                            Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="2"
                                            onClick={() => navigate(`/agency/pending-emails/` + e.id)}
                                        >
                                            Pending emails ({e?.invitedInfluencers?.length ?? 0})
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="3"
                                            onClick={() => navigate(`/agency/managers/${e.id}`)}
                                        >
                                            Managers ({e?.managersCount ?? 0})
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            eventKey="4"
                                            onClick={() => navigate(`/agency/influencers/${e.id}`)}
                                        >
                                            Influencers ({e?.influencersCount ?? 0})
                                        </Dropdown.Item>
                                    </DropdownButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    {agencies.length < 15 && !!agencies.length && <div className="h-180px"></div>}
                </Table>
            </TableLayout>
        </>
    );
}
